import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  padding-bottom: 8px;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  align-self: stretch;

  @media (min-width: ${({ theme }) => theme.mediaQueries.sm}) {
    min-height: 200px;
    min-width: 374px;
  }
`;

export const TitleWrapper = styled.div`
  color: ${({ theme }) => theme.colors.black9};
  text-align: center;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 32px;
  letter-spacing: -0.2px;
`;

export const EmojiWrapper = styled.div`
  font-size: 55px;
  padding: 13px;
`;
